(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-product"] && !window.DesignMode) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
           // Initialize Slick slider here after content has been loaded
          $('.you_may_also .products_grid').on('init', function(event, slick) {
            center_buttons( $('.you_may_also .products_grid'));
          });
          $('.you_may_also .products_grid').slick({
            slidesToShow: 5,
            slidesToScroll: 5,        
            dots: false,        
            focusOnSelect: false,
            infinite: true,
            arrows: true,
            responsive: [
              {
                breakpoint: 1080,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 4,
                }
              },
              {
                breakpoint: 749,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                }
              },
              {
                breakpoint: 525,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2,
                }
              }
            ]
          });
          $(window).on('resize', function() {
            center_buttons($('.you_may_also .products_grid'));
          });
          function center_buttons($element){
            let height = $element.find('.grid-view-item__image').height()/2 +"px"; 
            $element.find('.slick-arrow').css('top', height);
          }
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
